__turbopack_context__.v({
  "list": "Tabs-module__CZnaXG__list",
  "panel": "Tabs-module__CZnaXG__panel",
  "root": "Tabs-module__CZnaXG__root",
  "tab": "Tabs-module__CZnaXG__tab",
});
